import { RootState } from '@spa/lib/store/RootState';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';

const selectDefaultWishlist = ({
  wishlists: { wishlists }
}: RootState): StateWishlist | undefined =>
  wishlists.find(({ isDefault }: StateWishlist): boolean => isDefault);

export default selectDefaultWishlist;
